<template>
  <v-card>
    <v-card-actions>
      <v-col>
        <v-row align="center">
          <span>Fecha de levantamiento</span>
          <v-text-field
            style="padding-left: 10px"
            label="respuesta"
            v-model="lifting"
            :disabled="disabled"
            v-mask="mask"
            :class="{ 'disabled-text': disabled }"
            v-on:keyup="registerLifting(lifting)"
          ></v-text-field>
        </v-row>
        <v-row align="center">
          <span>Responsable del llenado</span>
          <v-text-field
            style="padding-left: 10px"
            :disabled="disabled"
            label="respuesta"
            v-model="filling"
            :class="{ 'disabled-text': disabled }"
            v-on:keyup="registerFilling(filling)"
          ></v-text-field
        ></v-row>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      info: "",
      lifting: "",
      filling: "",
      mask: "##/##/####",
    };
  },
  props: {
    fillingResponsable: String,
    liftingDate: String,
    disabled: Boolean,
  },
  methods: {
    registerFilling(value) {
      this.$emit("changeFilling", { value: value });
    },
    registerLifting(value) {
      this.$emit("changeLifting", { value: value });
    },
  },
  mounted() {
    this.lifting = this.liftingDate;
    this.filling = this.fillingResponsable;
  },
};
</script>
<style scoped>
.text {
  word-break: normal;
}

.disabled-text {
  font-weight: 500;
  color: black;
  -webkit-text-fill-color: black;
}
</style>